// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1HIlp","label":"SetPasswdForm_label__f9zta"};